const numberOfWeeks = (days) => Math.floor(days / 7);

const remainingNumberOfDays = (days) => days % 7;

const pluralize = (number, noun) => `${noun}${number > 1 ? 's' : ''}`;

export default function (daysUntilCompletion) {
  const weeks = numberOfWeeks(daysUntilCompletion);
  const days = remainingNumberOfDays(daysUntilCompletion);

  if (weeks >= 1 && days >= 1) {
    return `${weeks} ${pluralize(weeks, 'week')} and ${days} ${pluralize(
      days,
      'day'
    )}`;
  }

  if (weeks >= 1) {
    return `${weeks} ${pluralize(weeks, 'week')}`;
  }

  return `${days} ${pluralize(days, 'day')}`;
}
